import React from 'react';
import ReactDOM from 'react-dom/client';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './assets/css/reset.css';
import './assets/css/style.css';
import './assets/css/common.css';
import './assets/css/modal.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from './context/ConfigContext';
import { ModalProvider } from './components/UI/ModalProvider';
import { LockProvider } from './context/LockContext';
import { LockContext } from './context/LockContext';
import { AuthProvider } from './context/AuthContext';
import LockScreen from './components/LockScreen';

window.$ = window.jQuery = $;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ModalProvider>
        <AuthProvider>
          <ConfigProvider>
            <LockProvider>
              <LockContext.Consumer>
                {({ locked }) =>
                  locked ? (
                    <LockScreen />
                  ) : (
                    <App />
                  )
                }
              </LockContext.Consumer>
            </LockProvider>
          </ConfigProvider>
        </AuthProvider>
      </ModalProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
